
export default {
    name: 'HelpText',
    props: {
        text: {
            type: String,
            default: null,
        },
        inline: {
            type: Boolean,
            default: false,
        },
    },
}
